















import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { finishTask, saveExtraData } from '../../../../service/platform'
import { FinishTaskData, TaskInstance } from '../../types/task'
import ImageSample from './common/ImageSample.vue'
import SensitiveWords from './common/SensitiveWords.vue'
import { OperationMixin } from './OperationMixin'
import { Record } from './Record'

@Component({
  components: { ImageSample, SensitiveWords }
})
export default class AuditInfo extends Mixins(OperationMixin, Record) {
  private async pass() {
    const saveRet = await saveExtraData(this.extraData)
    if (!saveRet.success) return

    const submitData: FinishTaskData = {
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      approve_result: 'PASS',
      approve_reason: '',
      variable_data_json: '',
      extra_operation_data_json: ''
    }

    this.getFinishTime({
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      step: 'submit'
    })

    let retData = await finishTask(submitData)
    if (retData.success) {
      this.close(true)
    }
  }
}
